module.exports = __webpack_public_path__ + "b963c0e608d657a94333bfcaf9d5d01e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Pachantiew/22.jpg
// module id = 1349
// module chunks = 47